import React from 'react';
import {connect} from 'react-redux';
import './App.less';
import styles from './App.module.css';
import {hideChatbotWithDelay, showChatbotWithDelay, hidePopupMessage} from '@/store/slices/chatbotVisibility';
import store from '@/store/store';
import {OPEN_CHATBOT, CLOSE_CHATBOT, SET_CHATBOT_ID, notifyAppLoaded} from '@/helpers/loaderAPI';
import {loadChatbot, setCandidateID, setExid, setIsDirectLink, setSourceID, setUUID} from '@/store/slices/chatbotDetails';
import DirectLink from '@/components/directlink/DirectLink';
import Embed from '@/components/embed/Embed';

class App extends React.Component {


    componentDidMount() {
        window.addEventListener('message', this.receiveMessage, false);
        const paths = window.location.pathname.split('/');
        if (paths.length > 2) {
            const chatbotID = paths[2];
            // check if we have valid chatbotID and it's not the same as the one already loaded
            if (chatbotID && store.getState().chatbotDetails.UUID !== chatbotID) {
                const urlParams = new URLSearchParams(window.location.search);
                store.dispatch(setCandidateID(urlParams.get('id')));
                store.dispatch(setSourceID(urlParams.get('source')));
                store.dispatch(setExid(urlParams.get('exid')));
                store.dispatch(setIsDirectLink(true));
                store.dispatch(setUUID(chatbotID));
                store.dispatch(loadChatbot());
            }
        }

        notifyAppLoaded();
    }

    receiveMessage = (event) => {
        switch (event.data.type) {
            case SET_CHATBOT_ID:
                const chatbotID = event.data.value;
                if (store.getState().chatbotDetails.UUID !== chatbotID) {
                    store.dispatch(setUUID(chatbotID));
                    store.dispatch(loadChatbot());
                }
                break;
            case OPEN_CHATBOT:
                store.dispatch(showChatbotWithDelay());
                break;
            case CLOSE_CHATBOT:
                store.dispatch(hideChatbotWithDelay());
                break;
            default:
                break;
        }
    };

    chatbotWrapperOnClick = function (e) {
        if (['elay-chatbot-wrapper',
            'elay-chatbot-wrapper-row',
            'elay-chatbot-wrapper-col'].includes(e.target.id)
        ) {
            store.dispatch(hideChatbotWithDelay(499));
            store.dispatch(hidePopupMessage());
        }
    };

    render() {
        const props = this.props;
        return <div id="elay-chatbot-wrapper" className={styles.wrapper}
                    onClick={(props.isChatbotVisible || props.isPopupMessageVisible) && !props.isDirectLink ? this.chatbotWrapperOnClick : undefined}>
            {props.isDirectLink ? <DirectLink/> : <Embed/>}
        </div>;
    }
}


const mapStateToProps = state => ({
    isChatbotVisible: state.chatbotVisibility.animTransition,
    isPopupMessageVisible: state.chatbotVisibility.isPopupMessageVisible,
    isDirectLink: state.chatbotDetails.isDirectLink,
});

export default connect(mapStateToProps)(App);
